import { ReactNode, Ref } from "react"

export type AlertProps = {
  ref?: Ref<HTMLDivElement>
  children: ReactNode
}

export const Alert = ({ ref, children }: AlertProps) => {
  return (
    <div ref={ref} className="bg-brand-secondary-lighter rounded-xl p-8 text-pretty">
      {children}
    </div>
  )
}
